import { Inject, Injectable } from '@angular/core';
import { IControlliEffettuati, IPuntoCampionamento } from './punti-campionamento.model';
import { QueryService } from 'src/app/core/services/query.service';
import { PUNTI_CAMPIONAMENTO_EDIT_DATA_VALIDITA, PUNTI_CAMPIONAMENTO_ENDPOINT, PUNTI_CAMPIONAMENTO_QUERY_SERVICE_INSTANCE, PUNTI_CAMPIONAMENTO_SEND_FILE_ENDPOINT, PUNTI_CAMPIONAMENTO_DATI_EXCEL } from './punti-campionamento.config';
import { ApiService } from 'src/app/core/services/api.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { IFileBase64 } from 'src/app/core/models/file-base64.model';
import { IFilters } from 'src/app/core/models/filters.model';

@Injectable({
  providedIn: 'root'
})
export class PuntiCampionamentoService extends CrudService<IPuntoCampionamento> {

  constructor(
    @Inject(PUNTI_CAMPIONAMENTO_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<IPuntoCampionamento>,
    @Inject(ApiService) protected override readonly api: ApiService,
    @Inject(SnackbarService) protected override readonly snackbar: SnackbarService
  ) {
    // Chiamare il costruttore della classe padre con i parametri necessari
    super(PUNTI_CAMPIONAMENTO_ENDPOINT, api, snackbar);
  }

  sendFile(file: IFileBase64) {
    return this.api.post<any>(PUNTI_CAMPIONAMENTO_SEND_FILE_ENDPOINT, file);
  }
  checkElaborazioneFile(param:any){
    return this.api.get(`elaborazione/${param}`);
  }
  getControlliDettaglio(param:any){
    return this.api.get<IControlliEffettuati[]>(`last-dati-prelievo/${param}`);
  }

  sendEditDataValidita(data: any) {
    return this.api.post<any>(PUNTI_CAMPIONAMENTO_EDIT_DATA_VALIDITA, data);
  }

  getExcelData(filters: any) {
    let queryStrings: any;
    if (Object.keys(filters).length === 0) {
      queryStrings = '';
    } else if (Object.keys(filters).length > 0) {
      queryStrings = '&';
      let i = 0;
      for (let key in filters) {
        if (i === Object.keys(filters).length - 1) {
          var separator = '';
        } else {
          var separator = '&';
        }
        queryStrings += key.replace('_', '.') + '=' + filters[key] + separator;
        i++;
      }
    }

    return this.api.get(PUNTI_CAMPIONAMENTO_DATI_EXCEL + queryStrings);
  }
}
